import { CurrencySymbols, Currency } from '../constants/currency.js';

const getSymbolByCode = (code = Currency.RUB) => CurrencySymbols[code];

export { getSymbolByCode };
//# sourceMappingURL=getSymbolByCode.js.map
